/**
 * Product Navigation - Laoli Theme
 * Handles navigation functionality (go back buttons)
 */

function initPdpNavigation() {
  const mobileGoBack = document.querySelector('.laoli-pdp-mobile-goback');
  const desktopGoBack = document.querySelector('.laoli-pdp-desktop-goback');

  // Mobile go back button click handler
  if (mobileGoBack) {
    mobileGoBack.addEventListener('click', function() {
      if (document.referrer && document.referrer.includes(window.location.hostname)) {
        // If we came from the same site, go back
        window.history.back();
      } else {
        // If we came from external site or direct link, go to home page
        window.location.href = '/';
      }
    });
  }

  // Desktop go back button click handler (same as mobile)
  if (desktopGoBack) {
    desktopGoBack.addEventListener('click', function() {
      if (document.referrer && document.referrer.includes(window.location.hostname)) {
        // If we came from the same site, go back
        window.history.back();
      } else {
        // If we came from external site or direct link, go to home page
        window.location.href = '/';
      }
    });
  }
}

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { initPdpNavigation };
}
